module.exports = __webpack_public_path__ + "img/50111700.295aa0af.png";